export default __webpack_public_path__ + "static/media/5.c6d0cd16.png";